import React, { useState, useEffect, useContext } from 'react';
import TabPanelScheduleAvailability from './TabPanelScheduleAvailability'
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import styles from '../../styles/scheduleAvailability.module.css';
import { isAuthenticated } from '../../actions/authentication';
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../utils/token';
import { ChatContext } from '@/ChatProvider';

export function ScheduleAvailability(props) {
    const { setIsAuthenticated } = useContext(ChatContext);
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        handleTitle();

        handleToken();
    }, []);

    const handleToken = async () => {
        await RenewToken(props);

        isAuthenticated().then((result) => {
            setAuthenticated(result);
            setIsAuthenticated(result);
        });
    }

    const handleTitle = () => {
        props.onLoadTitle(i18next.t('menu:scheduleAvailability'));
    }

    return (
        authenticated &&  <div className={styles.rootScheduleAvailability}>
            <TabPanelScheduleAvailability />
        </div>
    );
}

export default withNamespaces(['menu'], { wait: true })(withCookies(ScheduleAvailability));